import api from './api';

export const authService = {

    async login(email, password) {
        return await api.post('/api/auth/sign-in/email', { email, password });
    },

    async sendEmailOtp(email) {
        return await api.post('/api/auth/email-otp/send-verification-otp', {
            email,
            type: 'sign-in'
        });
    },

    async verifyEmailOtp(email, otp) {
        return await api.post('/api/auth/sign-in/email-otp', {
            email,
            otp
        });
    },

    async sendPhoneOtp(phoneNumber) {
        return await api.post('/api/auth/phone-number/send-otp', {
            phoneNumber
        });
    },

    async verifyPhoneOtp(phoneNumber, code) {
        return await api.post('/api/auth/phone-number/verify', {
            phoneNumber,
            code
        });
    },


    async get_session() {
        const { data } = await api.get('/api/auth/get-session');
        return data;
    },

    async reset_pass_request(email) {
        // The reset URL is constructed server-side in `sendResetPassword`
        // with the token in the URL fragment. `redirectTo` here is unused
        // by the email flow, but kept for compatibility with better-auth's
        // origin validation.
        return await api.post('/api/auth/request-password-reset', {
            email,
            redirectTo: `${import.meta.env.VITE_APP_PUBLIC_SITE}/reset-password`
        });
    },

    async reset_pass(newPassword, token) {
        return await api.post('/api/auth/reset-password', {
            newPassword,
            token
        });
    },

};